import React from 'react';

import PropTypes from 'prop-types';

const LazyLoadedImage = ({ ...props }) => {
  const { loading } = props;
  const isPriority = loading === 'eager';
  const fetchPriority = isPriority ? 'high' : 'auto';
  // eslint-disable-next-line
  return <img fetchpriority={fetchPriority} {...props} />;
};

LazyLoadedImage.defaultProps = {
  loading: 'lazy',
};

LazyLoadedImage.propTypes = {
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
  loading: PropTypes.oneOf(['eager', 'lazy']),
  src: PropTypes.string.isRequired,
  srcSet: PropTypes.string,
};

export default LazyLoadedImage;
